import React from 'react';
import Image from 'next/image';

function StaticDisplay({ is_guide, columns }) {
  return (
    <div
      className={`grid grid-cols-1 grid-rows-1 ${columns.length === 2 ? 'mx-auto max-w-2xl gap-x-12 sm:grid-cols-2' : 'sm:grid-cols-3'} px-4 pt-0 sm:px-5 sm:pt-0 lg:px-0`}
    >
      {columns.map((item, index) => {
        const imageExists = item.image;
        const imageConnection = item.image;
        let imageHeightRatio = 0;
        let imageWidthNew = 0;
        if (imageExists) {
          if (imageConnection.dimension.height > 70) {
            // calculate the percentate we are reducing the height by so we can do the same with the width
            imageHeightRatio = (70 / imageConnection.dimension.height) * 100;
            // reduce width by the above %
            imageWidthNew = parseInt(
              (imageConnection.dimension.width / 100) * imageHeightRatio
            );
          }

          return (
            <div className="px-4 sm:max-w-sm" key={index}>
              <Image
                src={`${imageConnection.url}?height=60&disable=upscale`}
                width={`${is_guide ? 'auto' : imageWidthNew > 0 ? imageWidthNew : '70'}`}
                height={`${is_guide ? 'auto' : imageHeightRatio > 0 ? 70 : imageConnection.dimension.height ? imageConnection.dimension.height : '51'}`}
                alt={imageConnection.title.replace(/\.[^/.]+$/, '')}
                className="mx-auto max-h-[60px]"
              />
              {item.title && <h3 className="sh9 my-5">{item.title}</h3>}
              {item.description &&
                (item.description !== '' ||
                  item.description !== null ||
                  item.description !== undefined) && (
                  <p className="body-r my-4">{item.description}</p>
                )}
            </div>
          );
        } else {
          return (
            <div className="px-4 sm:max-w-sm" key={index}>
              {item.title && <h3 className="sh9 my-5">{item.title}</h3>}
              {item.description &&
                (item.description !== '' ||
                  item.description !== null ||
                  item.description !== undefined) && (
                  <p className="body-r my-4">{item.description}</p>
                )}
            </div>
          );
        }
      })}
    </div>
  );
}

export default StaticDisplay;
